import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AddOutletLayer } from "../components/AddOutletLayer";
import UnitListLayer from "../components/UnitListLayer";

export const UnitListPage = () => {
  return (
    <MasterLayout>
      {/* <Breadcrumb title="Add / Edit Outlet" /> */}
      <UnitListLayer/>
    </MasterLayout>
  );
};
